import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star, Home } from 'lucide-react';
interface PaymentConfirmationProps {
  onDone: () => void;
}
export function PaymentConfirmation({
  onDone
}: PaymentConfirmationProps) {
  return <motion.div initial={{
    opacity: 0,
    scale: 0.95
  }} animate={{
    opacity: 1,
    scale: 1
  }} className="flex h-full flex-col items-center justify-center bg-white px-6 text-center" data-id="element-116">
      <motion.div initial={{
      scale: 0
    }} animate={{
      scale: 1
    }} transition={{
      type: 'spring',
      damping: 15,
      stiffness: 200,
      delay: 0.2
    }} className="mb-6 flex h-24 w-24 items-center justify-center rounded-full bg-green-100 text-green-600" data-id="element-117">
        <Check className="h-12 w-12" strokeWidth={3} data-id="element-118" />
      </motion.div>

      <motion.h1 initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.4
    }} className="mb-2 text-2xl font-bold text-slate-900" data-id="element-119">
        Ride Complete!
      </motion.h1>

      <motion.p initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.5
    }} className="mb-8 text-slate-500" data-id="element-120">
        Hope you enjoyed your trip with Michael
      </motion.p>

      {/* Receipt Card */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.6
    }} className="mb-8 w-full rounded-2xl border border-slate-100 bg-slate-50 p-6" data-id="element-121">
        <div className="mb-6 flex items-center justify-between border-b border-slate-200 pb-6" data-id="element-122">
          <div className="text-left" data-id="element-123">
            <p className="text-xs text-slate-400" data-id="element-124">Total Paid</p>
            <p className="text-2xl font-bold text-slate-900" data-id="element-125">
              4.20{' '}
              <span className="text-sm font-medium text-slate-500" data-id="element-126">cUSD</span>
            </p>
          </div>
          <div className="flex items-center gap-2 rounded-full bg-blue-100 px-3 py-1 text-xs font-bold text-blue-700" data-id="element-127">
            <div className="h-2 w-2 rounded-full bg-blue-600" data-id="element-128"></div>
            MiniPay
          </div>
        </div>

        <div className="space-y-3" data-id="element-129">
          <div className="flex justify-between text-sm" data-id="element-130">
            <span className="text-slate-500" data-id="element-131">Ride Fare</span>
            <span className="font-medium text-slate-900" data-id="element-132">4.00 cUSD</span>
          </div>
          <div className="flex justify-between text-sm" data-id="element-133">
            <span className="text-slate-500" data-id="element-134">Platform Fee</span>
            <span className="font-medium text-slate-900" data-id="element-135">0.20 cUSD</span>
          </div>
        </div>
      </motion.div>

      {/* Rating */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.8
    }} className="mb-12" data-id="element-136">
        <p className="mb-4 text-sm font-medium text-slate-900" data-id="element-137">
          Rate your driver
        </p>
        <div className="flex gap-2" data-id="element-138">
          {[1, 2, 3, 4, 5].map(star => <button key={star} className="text-yellow-400 transition-transform hover:scale-110" data-id="element-139">
              <Star className="h-8 w-8 fill-current" data-id="element-140" />
            </button>)}
        </div>
      </motion.div>

      <motion.button initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 1
    }} whileTap={{
      scale: 0.98
    }} onClick={onDone} className="flex w-full items-center justify-center gap-2 rounded-full bg-slate-900 py-4 font-bold text-white shadow-lg transition-colors hover:bg-slate-800" data-id="element-141">
        <Home className="h-4 w-4" data-id="element-142" />
        Back to Home
      </motion.button>
    </motion.div>;
}